/*
 * @Description: 公司主数据相关接口
 */
import { RootObject } from '@/model/rootObject'
import https from '@/utils/https'
import { ContentType, Method } from 'axios-mapper'
import {
  CompanyInfoModel,
  CompanyListParamModel, CompanyPageParamModel, CreateCompanyModel, UpdateCompanyModel, CompanyPageModel,
  CompanySimpleInfoModel, CompanyBankModel
} from '@/model/master-data/companyModel'

const baseUrl = '/base/company'

export const createCompany = (companyInfo: CreateCompanyModel) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/add', Method.POST, companyInfo, ContentType.json)
}

export const deleteCompany = (companyId: number) => {
  return https().request<RootObject<number>>(baseUrl + '/delete/' + companyId, Method.POST, undefined, ContentType.json)
}

export const updateCompany = (companyInfo: UpdateCompanyModel) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/update', Method.POST, companyInfo, ContentType.json)
}

export const getCompanyById = (companyId: number) => {
  return https()
    .request<RootObject<CompanyInfoModel>>(baseUrl + '/get/' + companyId, Method.GET, undefined, ContentType.json)
}

export const getCompanyPageList = (params: CompanyPageParamModel) => {
  return https().request<RootObject<CompanyPageModel>>(baseUrl + '/list', Method.POST, params, ContentType.json)
}

export const getCompanyAllList = (params: CompanyListParamModel) => {
  return https().request<RootObject<CompanySimpleInfoModel[]>>(baseUrl + '/list/all', Method.POST, params, ContentType.json)
}

export const getBankInfoList = () => {
  return https().request<RootObject<CompanyBankModel[]>>(baseUrl + '/bank/list/all', Method.GET, undefined, ContentType.json)
}

export const getBankInfoForReceiptList = () => {
  return https().request<RootObject<CompanyBankModel[]>>(baseUrl + '/bank/list/forReceipt', Method.GET, undefined, ContentType.json)
}
